import { NetworkError } from './NetworkError.ts';

export class NoNetworkError extends NetworkError {
	/**
	 * If the call site of `cfetch` has indicated that `NoNetworkError`s are to be
	 * ignored by handlers, then `true`; otherwise, `false` or `undefined`.
	 */
	ignore?: boolean;
	/**
	 * Indicates whether the error was exposed to the feature gate `platform_editor_bubble_cfe_gql_network_errors`
	 * and subsequently bubbled up to the client. This property is used to track errors originating from this
	 * feature gate in analytics events.
	 *
	 * Note: This property is temporary and may be removed during the cleanup of the feature gate.
	 */
	wasBubbledUp?: boolean;
}
